<mat-tab-group animationDuration="0ms" class="layout-row-wrap gap-2percent layout-lt-md-column">
  @for (advancedPaymentAllocation of advancedPaymentAllocations; track advancedPaymentAllocation) {
    <mat-tab>
      <ng-template mat-tab-label>
        {{ advancedPaymentAllocation.transaction.value | translateKey: 'catalogs' }}
      </ng-template>
      <LOSx-advance-payment-allocation-tab
        [advancedPaymentAllocation]="advancedPaymentAllocation"
        (allocationChanged)="allocationChanged($event)"
        (transactionTypeRemoved)="transactionTypeRemoved($event)"
      >
      </LOSx-advance-payment-allocation-tab>
    </mat-tab>
  }

  @for (advancedCreditAllocation of advancedCreditAllocations; track advancedCreditAllocation) {
    <mat-tab>
      <ng-template mat-tab-label>
        {{ advancedCreditAllocation.transaction.value | translateKey: 'catalogs' }}
      </ng-template>
      <LOSx-advance-payment-allocation-tab
        [advancedCreditAllocation]="advancedCreditAllocation"
        (allocationChanged)="allocationChanged($event)"
        (transactionTypeRemoved)="transactionTypeRemoved($event)"
      >
      </LOSx-advance-payment-allocation-tab>
    </mat-tab>
  }

  <mat-tab>
    <ng-template mat-tab-label>
      <button (click)="addTransaction(); $event.stopPropagation()" mat-icon-button type="button">
        <mat-icon><fa-icon icon="plus" size="sm"></fa-icon></mat-icon>
      </button>
    </ng-template>
    <ng-template matTabContent></ng-template>
  </mat-tab>
</mat-tab-group>
